import { render, staticRenderFns } from "./AllImages.vue?vue&type=template&id=2a5defde&scoped=true&"
import script from "./AllImages.vue?vue&type=script&lang=js&"
export * from "./AllImages.vue?vue&type=script&lang=js&"
import style0 from "./AllImages.vue?vue&type=style&index=0&id=2a5defde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5defde",
  null
  
)

export default component.exports